import script from "./RosterSnackSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./RosterSnackSummary.vue?vue&type=script&lang=ts&setup=true"

import "./RosterSnackSummary.vue?vue&type=style&index=0&id=9978ca64&lang=scss"

const __exports__ = script;

export default __exports__